export default __webpack_public_path__ + "static/media/task5post.ee30080a.png";